import { Heading } from '@ksyos/design-system';
import { CarePathType } from '@common/enums/carePathType';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { useNavigateInTabBar } from '@frontend/utils/hooks/useNavigateInTabBar';
import { getSelectedLanguage } from '../../../../translate';
import { FinancingFlex } from './financingFlex/FinancingFlex';
import { FinancingOld } from './financingOld/FinancingOld';
import { FinancingTabBar } from './FinancingTabBar';

export function Financing() {
    const language = getSelectedLanguage();

    const { selectedTab } = useNavigateInTabBar() as { selectedTab: CarePathType };

    return (
        <PageTemplate>
            <Heading mb={4}>{language.common.funding}</Heading>
            <FinancingTabBar selectedTab={selectedTab || CarePathType.old} />
            {selectedTab === 'flex' ? <FinancingFlex /> : <FinancingOld />}
        </PageTemplate>
    );
}
